import { render, staticRenderFns } from "./Error-6.vue?vue&type=template&id=32d2f29e&"
import script from "./Error-6.vue?vue&type=script&lang=js&"
export * from "./Error-6.vue?vue&type=script&lang=js&"
import style0 from "./Error-6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports